import { useMutation, useQueryClient } from 'react-query'

import { QUERY_KEYS } from 'src/constants'
import { ratingSettingsService } from 'src/services/rating-settings.service'

import { IUpdateRatingSettingsDto } from 'src/types/rating-settings.type'

interface IProps {
  id: string
  item: IUpdateRatingSettingsDto
}

const useUpdateRatingSetting = () => {
  const queryClient = useQueryClient()

  return useMutation(
    async ({ id, item }: IProps) => {
      return ratingSettingsService.updateRatingSettings(id, item)
    },
    {
      onSuccess: (data) => {
        if (data) {
          queryClient.invalidateQueries(QUERY_KEYS.RATING_SETTINGS)
        }
      },
    },
  )
}

export { useUpdateRatingSetting }
